import { render, staticRenderFns } from "./CommentDetail.vue?vue&type=template&id=67d254b1&scoped=true&"
import script from "./CommentDetail.vue?vue&type=script&lang=ts&"
export * from "./CommentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CommentDetail.vue?vue&type=style&index=0&id=67d254b1&lang=less&scoped=true&"
import style1 from "./CommentDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d254b1",
  null
  
)

export default component.exports